import React from 'react'
import { colors } from 'src/theme'
import { Lexicons } from 'src/rest/types/Lexicon'
import { useTranslation } from 'react-i18next'

import LexiconTooltip from '../LexiconTooltip'

export type TooltipsProps = {
  lexicons: Lexicons
}

const Tooltips: React.FC<TooltipsProps> = ({ lexicons }) => {
  const { t } = useTranslation()
  return lexicons
    .filter((l) => l.word)
    .map((lexique) => (
      <LexiconTooltip
        key={lexique.documentId}
        content={t('lexicons.tooltip.content', { word: lexique.word })}
        color={colors.blueLight}
        anchorSelect={`[data-lexicon="${lexique.word.toLocaleLowerCase()}"]`}
      />
    ))
}

export default Tooltips
